import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { setDefaultTitle } from 'utilities/text/titleDefault.js';
import { NA_VALUE } from 'utilities/weather-station/location.js';
import { GeneralInformationComponent } from './factory/general-information.js';

export interface ISnowConditions {
  text: string[] | string;
  lowerSnowBase?: number | string;
  upperSnowBase?: number | string;
  issuedAt: string;
}

const getSnowStatus = (val?: string | number) => {
  if (val) {
    if (val === NA_VALUE) {
      return val;
    }
    return `${val}cm`;
  }
  return undefined;
};

export const SnowConditions = ({ config, isDrawer, modulePath }: IModule<ISnowConditions>) => {
  const { upperSnowBase, lowerSnowBase, text, issuedAt } = config;
  const upperStatus = getSnowStatus(upperSnowBase);
  const lowerStatus = getSnowStatus(lowerSnowBase);

  return (
    <Tile dataModule="snow-conditions" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2
          isDrawer={isDrawer}
          modulePath={modulePath}
          config={setDefaultTitle(config, 'Snow conditions')}
        />

        <GeneralInformationComponent
          headers={[
            { icon: 'mountain-upperbase', title: 'Upper snow base', status: upperStatus },
            { icon: 'mountain-lowerbase', title: 'Lower snow base', status: lowerStatus },
          ]}
          text={text}
          issuedAt={issuedAt}
        />
      </div>
    </Tile>
  );
};
